<script lang="ts" setup>
import YouCanDoThisCard from '../YouCanDoThis/YouCanDoThisCard.vue';

defineProps<{
  imageNumber: InstanceType<typeof YouCanDoThisCard>['$props']['imageNumber'];
}>();
</script>

<template>
  <YouCanDoThisCard :image-number="imageNumber">
    <template #titleText>
      <span :class="$style['youCanDoThisTitleText--accent']"
        >中立的な視点での</span
      >アドバイスとご提案
    </template>
    <template #detail>
      オカネコは複数の金融機関と提携しており、一般的な金融サービスとは異なり、住宅購入資金を含む幅広い資産形成の選択肢を提供できます。その中からあなたに本当に必要な資金計画を提案し、特定の会社に偏らない中立的な視点でのアドバイスを行います。無理に商品を押し売りせず、理想の暮らしや考えを踏まえたオリジナルの提案を行います。さらに、資産運用や住宅関連に詳しい経験豊富なFPが幅広い選択肢から対策を提案し、安心してご相談いただける環境を提供します。
    </template>
  </YouCanDoThisCard>
</template>

<style lang="scss" module>
.youCanDoThisTitleText {
  &--accent {
    color: $color-text-and-object-accent-primary;
  }
}
</style>
